import { FEATURE_PSEUDO_LOCALISATION } from '../constants';
import type { FeatureConfig } from '../types';

export const pseudoLocalisationFeature: FeatureConfig = {
  name: FEATURE_PSEUDO_LOCALISATION,
  toFeature() {
    return {
      name: this.name,
      // Always disabled; override it via the feature toggle UI
      enabled: false,
    };
  },
};
